var React = require('react');

function StatusError (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("path",{"d":"M16 3.273c7.03 0 12.727 5.698 12.727 12.727 0 7.03-5.698 12.727-12.727 12.727C8.97 28.727 3.273 23.03 3.273 16 3.273 8.97 8.97 3.273 16 3.273zm4.82 6.88L16 14.97l-4.82-4.819-1.028 1.029 4.82 4.818-4.82 4.82 1.029 1.029 4.818-4.82 4.82 4.82 1.029-1.029-4.82-4.82 4.82-4.818-1.029-1.029z"})));
}

StatusError.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = StatusError;

StatusError.default = StatusError;
